module.exports = __webpack_public_path__ + "img/48.58db90c0.png";